/**
 * 赠送信物
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message } from 'antd';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import * as Map from 'immutable';
import { DDLoading } from '../globalPageStatus';
import Util from '../../script/util';
import { _change_affinity_modal } from '../../../src/store/Action';
import iconAffinityListEmptyPNG from './img/affinity-list-empty.png';

class AffinityGive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      list: [],
      isMore: true,
      page: 1,
      size: 10,
      detail: {},
      num: 0,
      typeTab: 0,
      type: -32, //-32 信物 34趣味卡
      isBuy: false,
      callback: null,
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.affinityGiveModal);
    const props2 = Map.fromJS(this.props.base.affinityGiveModal);

    if (!this.props.base.affinityGiveModal) {
    } else if (this.props.base.affinityGiveModal && !Map.is(props1, props2)) {
      const { detail, type, isBuy, num, callback } =
        this.props.base.affinityGiveData;
      this.showModal(detail, type, isBuy, num, callback);
    }
  }

  showModal = (detail, type, isBuy, num, callback) => {
    this.setState(
      {
        visible: true,
        list: [],
        detail,
        type,
        isBuy,
        num,
        callback,
      },
      () => {
        this.getAffinityList(1);
      }
    );
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_affinity_modal({
      affinityInviteModal: false,
      affinityGiveModal: false,
    });
  };

  //赠送
  handleSend = (data) => {
    const { type, isBuy, callback } = this.state;
    let content = (
      <div className="affinity-send-box">
        <div className="affinity-send-avatar">
          <div className="affinity-send-line"></div>
          <img src={Util.transImgUrl(data.otherAvatar)} alt="" />
          <div className="affinity-send-line"></div>
        </div>
        <div className="affinity-send-text">确定赠送给</div>
        <div className="affinity-send-name">{data.otherNickName}吗？</div>
      </div>
    );
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: content,
      className: 'daidai-confirm-style daidai-confirm-affinity-style',
      okText: '确认',
      cancelText: '我再想想',
      centered: true,
      onOk: () => {
        const { detail, typeTab, num } = this.state;
        let url = '';
        let params = {};

        if (type == 34) {
          params = {
            receiveUid: data.otherUid,
            sendName: detail.additionals[typeTab],
            receiveName: detail.additionals[typeTab ? 0 : 1],
            type: isBuy ? 0 : 1,
            unit: detail.unit,
            num,
          };
          if (isBuy) {
            params.buyId = detail.id;
          } else {
            params.backId = detail.id;
          }
          url = '_send_interest_card';
        } else {
          params = {
            receiveUid: data.otherUid,
            giftId: detail.propId,
          };
          url = '_send_token_card';
        }
        HTTP[url](params).then((res) => {
          if (res.code == 200) {
            this.hideModal();
            this.props.hideModal && this.props.hideModal();
            Modal.info({
              title: '赠送成功',
              icon: null,
              closable: true,
              content: (
                <span>
                  {type == 34 ? '趣味关系卡' : '信物'}已装扮至你们的亲密空间，
                  TA也会收到{type == 34 ? '趣味关系卡' : '信物'}赠送消息噢～
                </span>
              ),
              className: 'daidai-confirm-style daidai-confirm-affinity-style',
              okText: '我知道了',
              centered: true,
              okType: 'default',
            });
            callback && callback();
          } else {
            message.error(res.message);
          }
        });
      },
    });
  };

  //获取亲密关系列表
  getAffinityList = (page = this.state.page) => {
    const { base: userInfo } = this.props;
    const { size, list } = this.state;
    let params = {
      page,
      size,
      searchUid: userInfo.uid,
    };
    HTTP._get_affinity_page(params).then((res) => {
      if (res.code == 200) {
        let data = res.data?.list || [];
        if (data?.length < size) {
          this.setState({ isMore: false });
        } else {
          this.setState({ isMore: true });
        }
        if (page != 1) {
          data = [...list, ...data];
        }
        this.setState({ list: data });
      } else {
        message.error(res.message);
      }
    });
  };

  onChangeTypeTab = (typeTab) => {
    this.setState({ typeTab: typeTab });
  };
  onScroll = (e) => {
    const { page, isMore } = this.state;
    if (!isMore) return;
    if (e.scrollTop == e.contentScrollHeight - e.clientHeight) {
      this.getAffinityList(page + 1);
    }
  };

  render() {
    const { loading, typeTab, detail, list, type, visible, isMore } =
      this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          zIndex={1002}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={`${type == 34 ? '赠送趣味关系卡' : '赠送信物'}`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="512px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <div className="affinity-modal-box">
              <Scrollbar
                ref={(el) => (this.scrollElement = el)}
                className="my-scroll-bar"
                style={{ height: '650px' }}
                onScroll={this.onScroll}
              >
                <div
                  className="token-box"
                  style={{
                    backgroundImage: `url(${Util.transImgUrl(detail?.backgroundPic)})`,
                  }}
                >
                  {detail?.rarityConfig ? (
                    <div className="rarity">
                      <img
                        src={Util.transImgUrl(detail?.rarityConfig?.labelImg)}
                        alt=""
                      />
                    </div>
                  ) : null}
                  <img src={Util.transImgUrl(detail?.titlePic)} alt="" />
                </div>
                <h2>
                  {detail?.name}{' '}
                  {type == 34 ? (
                    <span style={{ fontSize: '12px' }}>(30天)</span>
                  ) : null}
                </h2>
                {type == 34 ? (
                  <div className="affinity-interest-box">
                    <div className="affinity-interest-item">
                      <div className="affinity-interest-item-label">你是</div>
                      <div className="affinity-interest-item-content">
                        {detail?.additionals?.map((item, index) => (
                          <div
                            key={index}
                            className={`affinity-interest-item-cell ${typeTab == index ? 'active' : ''}`}
                            onClick={() => this.onChangeTypeTab(index)}
                          >
                            <span>{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="affinity-interest-item">
                      <div className="affinity-interest-item-label">TA是</div>
                      <div className="affinity-interest-item-content">
                        {detail?.additionals?.map((item, index) => (
                          <div
                            key={index}
                            className={`affinity-interest-item-cell ${typeTab != index ? 'active' : ''}`}
                            onClick={() => this.onChangeTypeTab(index ? 0 : 1)}
                          >
                            <span>{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : null}
                <h4>可赠送的亲密关系好友</h4>
                {detail?.otherTip ? <h5>{detail.otherTip}</h5> : null}
                {list.length > 0 ? (
                  <div className="affinity-table" style={{ marginTop: '12px' }}>
                    {list.map((item) => (
                      <div className="affinity-table-item" key={item.otherUid}>
                        <div className="affinity-table-left">
                          <div className="affinity-table-avatar">
                            <img
                              src={Util.transImgUrl(item?.otherAvatar, '50x50')}
                              alt=""
                            />
                          </div>
                          <div className="affinity-table-info">
                            <div className="affinity-table-name">
                              {item.otherNickName}
                            </div>
                            <div className="affinity-table-value">
                              亲密值:{item.intimate || 0}
                            </div>
                          </div>
                        </div>
                        <div className="affinity-table-right">
                          <div
                            className="affinity-table-btn btn-1"
                            onClick={() => this.handleSend(item)}
                          >
                            赠送
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="affinity-empty">
                    <img src={iconAffinityListEmptyPNG} alt="空" />
                    <p>暂无亲密关系好友</p>
                  </div>
                )}
                {!isMore && list.length > 0 && (
                  <div className="page-more">没有更多了</div>
                )}
              </Scrollbar>
            </div>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(AffinityGive, { withRef: true })
);
